import registrationStep from "../../registrationStep";
import NotFoundPage from "./NotFoundPage";

export default registrationStep(NotFoundPage, "not-found");



// WEBPACK FOOTER //
// ./src/registration/components/NotFound/index.js